import { render, staticRenderFns } from "./WageSupplement.TypeConfiguration.Capture.vue?vue&type=template&id=26158f24&scoped=true"
import script from "./WageSupplement.TypeConfiguration.Capture.vue?vue&type=script&lang=js"
export * from "./WageSupplement.TypeConfiguration.Capture.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26158f24",
  null
  
)

export default component.exports